import type { Step } from "react-joyride";

export const otRuleEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ແກ້ໄຂຂໍ້ກຳນົດ OT. ປັບແຕ່ງຂໍ້ມູນແລ້ວບັນທຶກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-rule-edit-back"]',
    content: "ກັບໄປລາຍລະອຽດຂໍ້ກຳນົດ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-rule-edit-form"]',
    content: "ແກ້ໄຂຂໍ້ມູນຂໍ້ກຳນົດ ແລະ ກົດບັນທຶກການແກ້ໄຂ.",
    placement: "top",
  },
];
